import { render } from "./dlistnum.vue?vue&type=template&id=216ac8f6"
import script from "./dlistnum.vue?vue&type=script&lang=js"
export * from "./dlistnum.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__